// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   IconButton,
//   InputBase,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FeedbackForm from "../FeedbackForm";
// import createInstance from "../../../api/axiosinstance";
// import Toast from "../../../utils/toast";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


// const InterviewerDashboard = () => {
//   const [interviews, setInterviews] = useState([]);
//   const [formData, setFormData] = useState({
//     interviewId: "",
//   });
//   const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
//   const aiDishaApi = createInstance("DISHA");
//   const organizationId = window.sessionStorage.getItem("organizationId");
//   const interviewerId = window.sessionStorage.getItem("orgUserId");
//   const { COLORS } = useThemeMode();

//   const fetchInterviews = async () => {
//     try {
//       const response = await aiDishaApi.get(
//         `/Org_User_upcoming_interviews?interviewer_id=${interviewerId}&organization_id=${organizationId}`
//       );
//       setInterviews(response.data["upcoming_interviews"]);
//       console.log("INTTT : ", response.data["upcoming_interviews"]);
//     } catch (error) {
//       console.log("Error fetching interview details", error);
//       Toast.error("Failed to fetch interviews. Please try again.");
//     }
//   };

//   const handleInterviewStatusChange = async (interview, status) => {
//     if (!window.confirm(`Are you sure you want to ${status} this interview?`))
//       return;
//     try {
//       const response = await aiDishaApi.patch(
//         `/accept/reject/interviews?organization_id=${organizationId}&interviewer_id=${interviewerId}&interview_id=${interview.interview_id}&Status=${status}`
//       );
//       if (response.data.message === "Interview Status Updated!") {
//         Toast.success(`Interview ${status.toLowerCase()}ed successfully!`);
//         fetchInterviews();
//       } else {
//         Toast.error(
//           `Failed to ${status.toLowerCase()} interview. Please try again.`
//         );
//       }
//     } catch (error) {
//       console.error(`Error ${status.toLowerCase()}ing interview:`, error);
//       const errorMessage =
//         error.response?.data?.detail ||
//         `Failed to ${status.toLowerCase()} interview. Please verify interview details.`;
//       Toast.error(errorMessage);
//     }
//   };

//   useEffect(() => {
//     console.log("Inside use effect");
//     fetchInterviews();
//   }, []);

//   const handleFeedbackModalOpen = (interviewIdTemp) => {
//     setFormData({
//       ...formData,
//       interviewId: interviewIdTemp,
//     });
//     setIsFeedbackModalOpen(true);
//   };

//   const handleFeedbackModalClose = () => {
//     setIsFeedbackModalOpen(false);
//   };

//   const columnHeader = [
//     {
//       slot: "Interview Slot",
//       round: "Interview Round",
//       link: "Meeting Link",
//       candidate: "Candidate Details",
//       job: "Job Details",
//       feedback: "Feedback",
//       status: "Status",
//       action: "Action",
//     },
//   ];

//   const formatDateTime = (dateTimeString) => {
//     if (!dateTimeString) return "N/A";

//     const date = new Date(dateTimeString);

//     const day = date.getDate().toString().padStart(2, "0");
//     const month = date.toLocaleString("default", { month: "short" });
//     const year = date.getFullYear();

//     const hours = date.getHours().toString().padStart(2, "0");
//     const minutes = date.getMinutes().toString().padStart(2, "0");

//     return `${day} ${month} ${year}, ${hours}:${minutes}`;
//   };

//   const getStatusDisplay = (acceptance) => {
//     if (acceptance === "True") return "Accepted";
//     if (acceptance === "False") return "Rejected";
//     if (acceptance === "Re-Schedule") return "Re-Scheduled";
//     return "Pending";
//   };

//   return (
//     <div style={{ backgroundColor: "white", minHeight: "80vh" }}>
//       <Box
//         display="grid"
//         gridTemplateColumns="repeat(12, 1fr)"
//         sx={{
//           marginTop: "auto",
//           alignItems: "center",
//           borderRadius: "10px",
//           padding: "1% 1%",
//         }}
//       >
//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", fontSize: "28px", color:COLORS.text }}
//           >
//             Interview Schedule
//           </Typography>
//         </Box>
//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Paper
//             sx={{
//               p: "2px 4px",
//               display: "flex",
//               width: "65%",
//               borderRadius: 2,
//               background:COLORS.primary,
//               border: COLORS.border,
//             }}
//           >
//             <IconButton
//               type="button"
//               sx={{ p: "8px", color: COLORS.text }}
//               aria-label="search"
//             >
//               <SearchIcon sx={{ color: COLORS.text }} />
//             </IconButton>
//             <InputBase
//               sx={{
//                 ml: 1,
//                 flex: 1,
//                 fontFamily: "poppins",
//                 "& .MuiInputBase-input::placeholder": {
//                   color: `${COLORS.text} !important`,
//                   opacity: 0.7,
//                 },
//               }}
//               placeholder="Search by Name, Email or Mobile number"
//               inputProps={{ "aria-label": "search google maps" }}
//             />
//           </Paper>
//         </Box>
//       </Box>
//       <Box xs={1} sx={{ backgroundColor: "#33333" }}>
//         <Grid container spacing={1} sx={{ justifyContent: "center" }}>
//           <Grid item xs={8}>
//             <TableContainer
//               component={Paper}
//               sx={{ marginTop: "25px", borderRadius: "10px" }}
//             >
//               <Table size="small">
//                 <TableHead sx={{ background: COLORS.primary }}>
//                   {columnHeader.map((header) => (
//                     <TableRow key={header.slot}>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           borderBottom: 0,
//                           borderLeft: COLORS.secondary,
//                           fontSize: "16px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {header.slot}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           borderBottom: 0,
//                           fontSize: "16px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {header.round}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           borderBottom: 0,
//                           fontSize: "16px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {header.link}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           borderBottom: 0,
//                           fontSize: "16px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {header.candidate}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           borderBottom: 0,
//                           fontSize: "16px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {header.job}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           borderBottom: 0,
//                           fontSize: "16px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {header.feedback}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           borderBottom: 0,
//                           fontSize: "16px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {header.status}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           borderBottom: 0,
//                           fontSize: "16px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {header.action}
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableHead>
//                 <TableBody>
//                   {interviews.map((interview) => (
//                     <TableRow
//                       key={interview.interview_id}
//                       sx={{ background: COLORS.background }}
//                     >
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           border: COLORS.secondary,
//                           textAlign: "center",
//                         }}
//                       >
//                         {formatDateTime(interview.interview_date_and_time)}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           border: COLORS.secondary,
//                           textAlign: "center",
//                         }}
//                       >
//                         {interview.round}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.button_red_bg,
//                           border: COLORS.secondary,
//                           textAlign: "center",
//                         }}
//                       >
//                         <a
//                           href={interview.meeting_link}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           {interview.meeting_link}
//                         </a>
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           border: COLORS.secondary,
//                           textAlign: "center",
//                         }}
//                       >
//                         {interview.candidate_name}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           border: COLORS.secondary,
//                           textAlign: "center",
//                         }}
//                       >
//                         {interview.job_title}
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           border: COLORS.secondary,
//                           textAlign: "center",
//                         }}
//                       >
//                         <Button
//                           variant="contained"
//                           sx={{
//                             background: COLORS.button_edit_bg,
//                             color: COLORS.text,
//                             "&:hover": { background: COLORS.hover_edit_btn },
//                             fontFamily: "poppins",
//                             height: "38px",
//                             width: "80px",
//                           }}
//                           onClick={() =>
//                             handleFeedbackModalOpen(interview.interview_id)
//                           }
//                         >
//                           Feedback
//                         </Button>
//                       </TableCell>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           border: COLORS.secondary,
//                           textAlign: "center",
//                         }}
//                       >
//                         {/* {interview.Interviewer_acceptance} */}

//                         {Array.isArray(interview.Interviewer_acceptance)
//   ? (
//       interview.Interviewer_acceptance.find(
//         (item) => item.interviewer_id === interviewerId
//       )?.status || "Pending"
//     )
//   : "Pending"}
//                       </TableCell>
//                       <TableCell
//                         sx={{ border: COLORS.secondary, textAlign: "center" }}
//                       >
//                         <Select
//                           value={
//                             interview.Interviewer_acceptance === "True"
//                               ? "Accept"
//                               : interview.Interviewer_acceptance === "False"
//                               ? "Reject"
//                               : interview.Interviewer_acceptance ===
//                                 "Re-Schedule"
//                               ? "Re-Schedule"
//                               : ""
//                           }
//                           onChange={(e) =>
//                             handleInterviewStatusChange(
//                               interview,
//                               e.target.value
//                             )
//                           }
//                           displayEmpty
//                           sx={{
//                            background: COLORS.background,
//                             color: COLORS.text,
//                             fontFamily: "poppins",
//                             height: "38px",
//                             "& .MuiSelect-icon": {
//                               color: COLORS.text,
//                             },
//                             "&:hover": {
//                               background: COLORS.hoverBg,
//                             },
//                           }}
//                         >
//                           <MenuItem value="" disabled sx={{color : "black"}}>
//                             Select Action
//                           </MenuItem >
//                           <MenuItem value="Accept" sx={{color : "black"}}>Accept</MenuItem>
//                           <MenuItem value="Reject" sx={{color : "black"}}>Reject</MenuItem>
//                           <MenuItem value="Re-Schedule" sx={{color : "black"}}>Re-Schedule</MenuItem>
//                         </Select>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </Grid>
//         </Grid>
//       </Box>
//       <FeedbackForm
//         isOpen={isFeedbackModalOpen}
//         onClose={handleFeedbackModalClose}
//         organizationId={organizationId}
//         interviewId={formData.interviewId}
//       />
//       <br />
//       <br />
//       <br />
//       <br />
//       <br />
//       <br />
//     </div>
//   );
// };

// export default InterviewerDashboard;
























































// import React, { useState, useEffect, useRef } from "react";
// import {
//   Box,
//   Button,
//   IconButton,
//   InputBase,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   Select,
//   MenuItem,
//   Tooltip,
//   Modal,
//   Divider,
//   CircularProgress,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import VideoCallIcon from "@mui/icons-material/VideoCall";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import LogoutIcon from "@mui/icons-material/Logout";
// import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
// import CloseIcon from "@mui/icons-material/Close";
// import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
// import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
// import FeedbackForm from "../FeedbackForm";
// import createInstance from "../../../api/axiosinstance";
// import Toast from "../../../utils/toast";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";
// import { logout } from "../../../Redux/slices/authSlice";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";






// // ─── Difficulty badge colors ───────────────────────────────────────────────
// const DIFFICULTY_STYLES = {
//   Easy:   { bg: "#E8F5E9", color: "#22C55E" },
//   Medium: { bg: "#FFF3E0", color: "#F59E0B" },
//   Hard:   { bg: "#FEECEC", color: "#EF4444" },
// };

// // ─── Type badge colors ─────────────────────────────────────────────────────
// const TYPE_STYLES = {
//   Technical:           { bg: "#EDE9FE", color: "#8B5CF6" },
//   "Scenario-Based":    { bg: "#E0F2FE", color: "#0284C7" },
//   HR:                  { bg: "#FCE7F3", color: "#DB2777" },
//   "Missing Skills (AI/ML)": { bg: "#FEF3C7", color: "#D97706" },
// };

// // ─── Parse the raw API string → structured array ──────────────────────────
// const parseQuestions = (raw) => {
//   try {
//     const cleaned = typeof raw === "string" ? raw.replace(/^"|"$/g, "").replace(/\\n/g, "\n").replace(/\\"/g, '"') : raw;
//     const obj = typeof cleaned === "string" ? JSON.parse(cleaned) : cleaned;
//     return obj?.interview_questions || [];
//   } catch {
//     return [];
//   }
// };

// const InterviewerDashboard = () => {
//   const [interviews, setInterviews]               = useState([]);
//   const [searchQuery, setSearchQuery]             = useState("");
//   const [activeFilter, setActiveFilter]           = useState("all");
//   const [formData, setFormData]                   = useState({ interviewId: "" });
//   const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

//   // Profile popup
//   const [profileOpen, setProfileOpen]             = useState(false);
//   const profileRef                                = useRef(null);

//   // Questions modal
//   const [questionsOpen, setQuestionsOpen]         = useState(false);
//   const [questionsLoading, setQuestionsLoading]   = useState(false);
//   const [questions, setQuestions]                 = useState([]);
//   const [activeQType, setActiveQType]             = useState("All");
//   const [selectedInterview, setSelectedInterview] = useState(null);

//   const aiDishaApi     = createInstance("DISHA");
//   const organizationId = window.sessionStorage.getItem("organizationId");
//   const interviewerId  = window.sessionStorage.getItem("orgUserId");
//   const interviewerName= window.sessionStorage.getItem("userName") || "Interviewer";
//   const interviewerEmail= window.sessionStorage.getItem("userEmail") || "";
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { COLORS } = useThemeMode();

//   // Close profile popup on outside click
//   useEffect(() => {
//     const handler = (e) => {
//       if (profileRef.current && !profileRef.current.contains(e.target)) {
//         setProfileOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   // ── Data fetching ──────────────────────────────────────────────────────
//   const fetchInterviews = async () => {
//     try {
//       const response = await aiDishaApi.get(
//         `/Org_User_upcoming_interviews?interviewer_id=${interviewerId}&organization_id=${organizationId}`
//       );
//       setInterviews(response.data["upcoming_interviews"]);
//     } catch (error) {
//       console.log("Error fetching interview details", error);
//       Toast.error("Failed to fetch interviews. Please try again.");
//     }
//   };

//   const handleGenerateQuestions = async (interview) => {
//     setSelectedInterview(interview);
//     setQuestionsOpen(true);
//     setQuestionsLoading(true);
//     setQuestions([]);
//     setActiveQType("All");
//     try {
//       const response = await aiDishaApi.post(
//         `/generate_interview_questions?candidate_id=${interview.candidate_id}`
//       );
//       const parsed = parseQuestions(response.data);
//       setQuestions(parsed);
//     } catch (error) {
//       console.error("Error generating questions:", error);
//       Toast.error("Failed to generate questions. Please try again.");
//       setQuestionsOpen(false);
//     } finally {
//       setQuestionsLoading(false);
//     }
//   };

//   const handleInterviewStatusChange = async (interview, status) => {
//     if (!window.confirm(`Are you sure you want to ${status} this interview?`)) return;
//     try {
//       const response = await aiDishaApi.patch(
//         `/accept/reject/interviews?organization_id=${organizationId}&interviewer_id=${interviewerId}&interview_id=${interview.interview_id}&Status=${status}`
//       );
//       if (response.data.message === "Interview Status Updated!") {
//         Toast.success(`Interview ${status.toLowerCase()}ed successfully!`);
//         fetchInterviews();
//       } else {
//         Toast.error(`Failed to ${status.toLowerCase()} interview. Please try again.`);
//       }
//     } catch (error) {
//       console.error(`Error ${status.toLowerCase()}ing interview:`, error);
//       const errorMessage =
//         error.response?.data?.detail ||
//         `Failed to ${status.toLowerCase()} interview. Please verify interview details.`;
//       Toast.error(errorMessage);
//     }
//   };


//   const handleLogOut = () => {
//       localStorage.clear();
//       sessionStorage.clear();
//       dispatch(logout());
//       setTimeout(() => navigate("/"), 0);
//     };

//   useEffect(() => { fetchInterviews(); }, []);

//   const handleFeedbackModalOpen  = (id) => { setFormData({ interviewId: id }); setIsFeedbackModalOpen(true); };
//   const handleFeedbackModalClose = () => setIsFeedbackModalOpen(false);

//   // ── Helpers ────────────────────────────────────────────────────────────
//   const formatDate = (dateTimeString) => {
//     if (!dateTimeString) return { date: "N/A", time: "" };
//     const date  = new Date(dateTimeString);
//     const day   = date.getDate().toString().padStart(2, "0");
//     const month = date.toLocaleString("default", { month: "short" });
//     const year  = date.getFullYear();
//     const hours   = date.getHours().toString().padStart(2, "0");
//     const minutes = date.getMinutes().toString().padStart(2, "0");
//     return { date: `${day} ${month} ${year}`, time: `${hours}:${minutes}` };
//   };

//   const getInterviewerStatus = (interview) => {
//     if (Array.isArray(interview.Interviewer_acceptance)) {
//       return interview.Interviewer_acceptance.find(
//         (item) => item.interviewer_id === interviewerId
//       )?.status || "Pending";
//     }
//     return "Pending";
//   };

//   const getStatusChip = (status) => {
//     const map = {
//       Pending:       { label: "Pending",      bg: "#FFF8E1", color: "#F59E0B" },
//       Accept:        { label: "Accepted",     bg: "#E8F5E9", color: "#22C55E" },
//       Reject:        { label: "Rejected",     bg: "#FEECEC", color: "#EF4444" },
//       "Re-Schedule": { label: "Re-scheduled", bg: "#EDE9FE", color: "#8B5CF6" },
//     };
//     const s = map[status] || map["Pending"];
//     return (
//       <Box sx={{ display: "inline-flex", alignItems: "center", gap: "6px", px: "10px", py: "3px", borderRadius: "20px", background: s.bg, fontSize: "12px", fontWeight: 500, color: s.color, fontFamily: "Poppins", whiteSpace: "nowrap" }}>
//         <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: s.color, flexShrink: 0 }} />
//         {s.label}
//       </Box>
//     );
//   };

//   const getSelectValue = (interview) => {
//     const s = getInterviewerStatus(interview);
//     return ["Accept", "Reject", "Re-Schedule"].includes(s) ? s : "";
//   };

//   const getInitials = (name) =>
//     name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2);

//   // ── Stats ──────────────────────────────────────────────────────────────
//   const totalUpcoming = interviews.length;
//   const totalAccepted = interviews.filter((i) => getInterviewerStatus(i) === "Accept").length;
//   const totalPending  = interviews.filter((i) => getInterviewerStatus(i) === "Pending").length;

//   // ── Filter + search ────────────────────────────────────────────────────
//   const filteredInterviews = interviews.filter((interview) => {
//     const status = getInterviewerStatus(interview).toLowerCase();
//     const matchesFilter =
//       activeFilter === "all" ||
//       (activeFilter === "accepted" && status === "accept") ||
//       (activeFilter === "pending"  && status === "pending") ||
//       (activeFilter === "rejected" && status === "reject");
//     const q = searchQuery.toLowerCase();
//     const matchesSearch =
//       !q ||
//       interview.candidate_name?.toLowerCase().includes(q) ||
//       interview.job_title?.toLowerCase().includes(q) ||
//       interview.round?.toLowerCase().includes(q);
//     return matchesFilter && matchesSearch;
//   });

//   // ── Questions filtering ────────────────────────────────────────────────
//   const qTypes        = ["All", ...new Set(questions.map((q) => q.type))];
//   const visibleQs     = activeQType === "All" ? questions : questions.filter((q) => q.type === activeQType);

//   // ── Stat card config ───────────────────────────────────────────────────
//   const statCards = [
//     { label: "Upcoming",  value: totalUpcoming, sub: "Total scheduled",  icon: <CalendarTodayIcon sx={{ fontSize: 15 }} /> },
//     { label: "Accepted",  value: totalAccepted, sub: "Confirmed",         icon: <CheckCircleOutlineIcon sx={{ fontSize: 15 }} /> },
//     { label: "Pending",   value: totalPending,  sub: "Awaiting action",   icon: <AccessTimeIcon sx={{ fontSize: 15 }} /> },
//     { label: "Feedback",  value: totalAccepted, sub: "To submit",         icon: <ChatBubbleOutlineIcon sx={{ fontSize: 15 }} /> },
//   ];

//   const filterOptions  = [
//     { key: "all",      label: "All" },
//     { key: "pending",  label: "Pending" },
//     { key: "accepted", label: "Accepted" },
//     { key: "rejected", label: "Rejected" },
//   ];

//   const columnHeaders = ["Interview Slot", "Candidate", "Job", "Round", "Meeting", "Status", "Action"];

//   // ── Shared sx helpers ──────────────────────────────────────────────────
//   const cellSx  = { px: "14px", py: "12px", border: 0 };
//   const textSx  = { fontFamily: "Poppins", fontSize: "13px", color: COLORS.text };

//   return (
//     <Box sx={{ backgroundColor: COLORS.background, minHeight: "100vh", p: "24px 28px" }}>

//       {/* ── Top Bar ── */}
//       <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 3 }}>
//         <Box>
//           <Typography sx={{ fontFamily: "Poppins", fontSize: "20px", fontWeight: 500, color: COLORS.text }}>
//             Interview Schedule
//           </Typography>
//           <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: COLORS.text, opacity: 0.5, mt: "2px" }}>
//             {new Date().toLocaleDateString("en-GB", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
//           </Typography>
//         </Box>

//         {/* Profile avatar + popup */}
//         <Box ref={profileRef} sx={{ position: "relative" }}>
//           <Tooltip title="Profile">
//             <Box
//               onClick={() => setProfileOpen((p) => !p)}
//               sx={{
//                 width: 38, height: 38, borderRadius: "50%",
//                 background: COLORS.button_edit_bg,
//                 display: "flex", alignItems: "center", justifyContent: "center",
//                 fontSize: "13px", fontWeight: 600, color: COLORS.text, fontFamily: "Poppins",
//                 cursor: "pointer", border: COLORS.border,
//                 "&:hover": { opacity: 0.85 },
//               }}
//             >
//               {/* {getInitials(interviewerName)} */}
//               <AccountCircleIcon sx={{ fontSize: 35 }} />
//             </Box>
//           </Tooltip>

//           {/* Dropdown popup */}
//           {profileOpen && (
//             <Box
//               sx={{
//                 position: "absolute", top: "48px", right: 0, zIndex: 1300,
//                 background: COLORS.primary, border: COLORS.border,
//                 borderRadius: "12px", width: "230px",
//                 boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
//                 overflow: "hidden",
//               }}
//             >
//               {/* Header */}
//               <Box sx={{ px: "16px", pt: "16px", pb: "12px" }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                   <Box sx={{
//                     width: 40, height: 40, borderRadius: "50%",
//                     background: COLORS.button_edit_bg,
//                     display: "flex", alignItems: "center", justifyContent: "center",
//                     fontSize: "14px", fontWeight: 600, color: COLORS.text, fontFamily: "Poppins",
//                     flexShrink: 0,
//                   }}>
//                     {getInitials(interviewerName)}
//                   </Box>
//                   <Box sx={{ overflow: "hidden" }}>
//                     <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", fontWeight: 600, color: COLORS.text, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
//                       {interviewerName}
//                     </Typography>
//                     <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", color: COLORS.text, opacity: 0.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
//                       {interviewerEmail}
//                     </Typography>
//                   </Box>
//                 </Box>

//                 {/* Online status */}
//                 <Box sx={{ display: "flex", alignItems: "center", gap: "5px", mt: "10px" }}>
//                   <FiberManualRecordIcon sx={{ fontSize: 10, color: "#22C55E" }} />
//                   <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", color: "#22C55E", fontWeight: 500 }}>
//                     Online
//                   </Typography>
//                 </Box>
//               </Box>

//               <Divider sx={{ borderColor: COLORS.border?.replace("1px solid ", "") || "#eee" }} />

//               {/* Menu items */}
//               <Box sx={{ py: "8px" }}>
//                 <Box
//                   sx={{
//                     display: "flex", alignItems: "center", gap: "10px",
//                     px: "16px", py: "9px", cursor: "pointer",
//                     "&:hover": { background: COLORS.background },
//                   }}
//                 >
//                   <PersonOutlineIcon sx={{ fontSize: 17, color: COLORS.text, opacity: 0.6 }} />
//                   <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: COLORS.text }}>
//                     Interviewer Dashboard
//                   </Typography>
//                 </Box>

//                 <Divider sx={{ borderColor: COLORS.border?.replace("1px solid ", "") || "#eee", my: "4px" }} />

//                 <Box
//                   onClick={handleLogOut}
//                   sx={{
//                     display: "flex", alignItems: "center", gap: "10px",
//                     px: "16px", py: "9px", cursor: "pointer",
//                     "&:hover": { background: "#FEECEC" },
//                   }}
//                 >
//                   <LogoutIcon sx={{ fontSize: 17, color: "#EF4444" }} />
//                   <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: "#EF4444", fontWeight: 500 }}>
//                     Logout
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           )}
//         </Box>
//       </Box>

//       {/* ── Stat Cards ── */}
//       <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "12px", mb: 3 }}>
//         {statCards.map((card) => (
//           <Box key={card.label} sx={{ background: COLORS.primary, border: COLORS.border, borderRadius: "12px", p: "14px 16px" }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mb: "6px", color: COLORS.text, opacity: 0.55 }}>
//               {card.icon}
//               <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.05em" }}>
//                 {card.label}
//               </Typography>
//             </Box>
//             <Typography sx={{ fontFamily: "Poppins", fontSize: "24px", fontWeight: 500, color: COLORS.text }}>
//               {card.value}
//             </Typography>
//             <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, opacity: 0.45, mt: "2px" }}>
//               {card.sub}
//             </Typography>
//           </Box>
//         ))}
//       </Box>

//       {/* ── Toolbar ── */}
//       <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
//         <Paper sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: "260px", borderRadius: "8px", background: COLORS.primary, border: COLORS.border, boxShadow: "none" }}>
//           <IconButton sx={{ p: "6px", color: COLORS.text }} aria-label="search">
//             <SearchIcon sx={{ fontSize: 18 }} />
//           </IconButton>
//           <InputBase
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             placeholder="Search candidate, job or round…"
//             sx={{ ml: 0.5, flex: 1, fontFamily: "Poppins", fontSize: "13px", "& .MuiInputBase-input::placeholder": { color: `${COLORS.text} !important`, opacity: 0.5 }, color: COLORS.text }}
//           />
//         </Paper>

//         <Box sx={{ display: "flex", gap: "6px" }}>
//           {filterOptions.map((f) => (
//             <Box
//               key={f.key}
//               onClick={() => setActiveFilter(f.key)}
//               sx={{
//                 px: "14px", py: "5px", borderRadius: "20px", cursor: "pointer",
//                 fontFamily: "Poppins", fontSize: "12px", fontWeight: 500,
//                 border: "0.5px solid",
//                 borderColor: activeFilter === f.key ? "transparent" : COLORS.border?.replace("1px solid ", "") || "#ddd",
//                 background: activeFilter === f.key ? COLORS.button_edit_bg : COLORS.primary,
//                 color: COLORS.text,
//                 transition: "background 0.15s",
//               }}
//             >
//               {f.label}
//             </Box>
//           ))}
//         </Box>
//       </Box>

//       {/* ── Table ── */}
//       <TableContainer component={Paper} sx={{ borderRadius: "12px", border: COLORS.border, boxShadow: "none", background: COLORS.primary }}>
//         <Table size="small">
//           <TableHead sx= {{background: COLORS.primary}}>
//             <TableRow>
//               {columnHeaders.map((h) => (
//                 <TableCell key={h} sx={{ fontFamily: "Poppins", fontSize: "11px", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.05em", color: COLORS.text, opacity: 0.55, borderBottom: COLORS.border, py: "10px", px: "14px" }}>
//                   {h}
//                 </TableCell>
//               ))}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {filteredInterviews.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={7} sx={{ textAlign: "center", py: 5, color: COLORS.text, opacity: 0.4, fontFamily: "Poppins", fontSize: "14px", border: 0 }}>
//                   No interviews found
//                 </TableCell>
//               </TableRow>
//             ) : (
//               filteredInterviews.map((interview) => {
//                 const { date, time } = formatDate(interview.interview_date_and_time);
//                 const status = getInterviewerStatus(interview);
//                 return (
//                   <TableRow
//                     key={interview.interview_id}
//                     sx={{ background: COLORS.background, borderBottom: COLORS.border, "&:last-child td": { borderBottom: 0 }, transition: "background 0.1s" }}
//                   >
//                     {/* Slot */}
//                     <TableCell sx={cellSx}>
//                       <Typography sx={{ ...textSx, fontWeight: 500 }}>{date}</Typography>
//                       <Typography sx={{ ...textSx, fontSize: "12px", opacity: 0.5, mt: "1px" }}>{time}</Typography>
//                     </TableCell>

//                     {/* Candidate */}
//                     <TableCell sx={cellSx}>
//                       <Typography sx={{ ...textSx, fontWeight: 500 }}>{interview.candidate_name}</Typography>
//                     </TableCell>

//                     {/* Job */}
//                     <TableCell sx={cellSx}>
//                       <Typography sx={textSx}>{interview.job_title}</Typography>
//                     </TableCell>

//                     {/* Round */}
//                     <TableCell sx={cellSx}>
//                       <Box sx={{ display: "inline-flex", alignItems: "center", px: "10px", py: "3px", borderRadius: "20px", background: COLORS.button_edit_bg, fontFamily: "Poppins", fontSize: "11px", fontWeight: 500, color: COLORS.text, whiteSpace: "nowrap" }}>
//                         {interview.round}
//                       </Box>
//                     </TableCell>

//                     {/* Meeting */}
//                     <TableCell sx={cellSx}>
//                       <Box component="a" href={interview.meeting_link} target="_blank" rel="noopener noreferrer"
//                         sx={{ display: "inline-flex", alignItems: "center", gap: "4px", px: "10px", py: "4px", borderRadius: "6px", background: COLORS.button_edit_bg, color: COLORS.text, textDecoration: "none", fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, "&:hover": { opacity: 0.8 } }}
//                       >
//                         <VideoCallIcon sx={{ fontSize: 15 }} /> Join
//                       </Box>
//                     </TableCell>

//                     {/* Status */}
//                     <TableCell sx={cellSx}>{getStatusChip(status)}</TableCell>

//                     {/* Action */}
//                     <TableCell sx={cellSx}>
//                       <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
//                         <Select
//                           value={getSelectValue(interview)}
//                           onChange={(e) => handleInterviewStatusChange(interview, e.target.value)}
//                           displayEmpty
//                           sx={{ fontFamily: "Poppins", fontSize: "12px", height: "32px", background: COLORS.background, color: COLORS.text, border: COLORS.border, borderRadius: "6px", "& .MuiSelect-icon": { color: COLORS.text }, "& .MuiOutlinedInput-notchedOutline": { border: "none" }, "&:hover": { background: COLORS.primary } }}
//                         >
//                           <MenuItem value="" disabled sx={{ color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Action</MenuItem>
//                           <MenuItem value="Accept"      sx={{ color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Accept</MenuItem>
//                           <MenuItem value="Reject"      sx={{ color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Reject</MenuItem>
//                           <MenuItem value="Re-Schedule" sx={{ color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Re-schedule</MenuItem>
//                         </Select>

//                         {/* Feedback */}
//                         <Tooltip title="Submit feedback">
//                           <IconButton size="small" onClick={() => handleFeedbackModalOpen(interview.interview_id)}
//                             sx={{ color: COLORS.text, border: COLORS.border, borderRadius: "6px", p: "5px", background: COLORS.background, "&:hover": { background: COLORS.primary } }}
//                           >
//                             <ChatBubbleOutlineIcon sx={{ fontSize: 22 }} />
//                           </IconButton>
//                         </Tooltip>

//                         {/* Generate Questions */}
//                         <Tooltip title="Generate interview questions">
//                           <IconButton size="small" onClick={() => handleGenerateQuestions(interview)}
//                             sx={{ color: "#8B5CF6", border: "1px solid #EDE9FE", borderRadius: "6px", p: "5px", background: "#EDE9FE", "&:hover": { background: "#DDD6FE" } }}
//                           >
//                             <AutoAwesomeIcon sx={{ fontSize: 22 }} />
//                           </IconButton>
//                         </Tooltip>
//                       </Box>
//                     </TableCell>
//                   </TableRow>
//                 );
//               })
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* ── Feedback Form ── */}
//       <FeedbackForm
//         isOpen={isFeedbackModalOpen}
//         onClose={handleFeedbackModalClose}
//         organizationId={organizationId}
//         interviewId={formData.interviewId}
//       />

//       {/* ── Interview Questions Modal ── */}
//       <Modal open={questionsOpen} onClose={() => setQuestionsOpen(false)}>
//         <Box
//           sx={{
//             position: "absolute", top: "50%", left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: { xs: "95vw", md: "780px" },
//             maxHeight: "88vh",
//             background: COLORS.background,
//             borderRadius: "16px",
//             boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
//             display: "flex", flexDirection: "column",
//             overflow: "hidden",
//           }}
//         >
//           {/* Modal Header */}
//           <Box sx={{ px: "24px", py: "18px", background: COLORS.primary, borderBottom: COLORS.border, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               <Box sx={{ width: 34, height: 34, borderRadius: "8px", background: "#EDE9FE", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 <AutoAwesomeIcon sx={{ fontSize: 18, color: "#8B5CF6" }} />
//               </Box>
//               <Box>
//                 <Typography sx={{ fontFamily: "Poppins", fontSize: "15px", fontWeight: 600, color: COLORS.text }}>
//                   AI-Generated Interview Questions
//                 </Typography>
//                 {selectedInterview && (
//                   <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, opacity: 0.5 }}>
//                     {selectedInterview.candidate_name} · {selectedInterview.job_title} · {selectedInterview.round}
//                   </Typography>
//                 )}
//               </Box>
//             </Box>
//             <IconButton onClick={() => setQuestionsOpen(false)} sx={{ color: COLORS.text, p: "6px" }}>
//               <CloseIcon sx={{ fontSize: 20 }} />
//             </IconButton>
//           </Box>

//           {/* Loading state */}
//           {questionsLoading ? (
//             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 8, gap: 2 }}>
//               <CircularProgress size={36} sx={{ color: "#8B5CF6" }} />
//               <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: COLORS.text, opacity: 0.6 }}>
//                 Generating questions…
//               </Typography>
//             </Box>
//           ) : (
//             <>
//               {/* Type filter tabs */}
//               <Box sx={{ px: "24px", py: "12px", display: "flex", gap: "6px", flexWrap: "wrap", borderBottom: COLORS.border, background: COLORS.primary, flexShrink: 0 }}>
//                 {qTypes.map((t) => (
//                   <Box
//                     key={t}
//                     onClick={() => setActiveQType(t)}
//                     sx={{
//                       px: "12px", py: "4px", borderRadius: "20px", cursor: "pointer",
//                       fontFamily: "Poppins", fontSize: "12px", fontWeight: 500,
//                       border: "0.5px solid",
//                       borderColor: activeQType === t ? "transparent" : COLORS.border?.replace("1px solid ", "") || "#ddd",
//                       background: activeQType === t ? "#EDE9FE" : COLORS.background,
//                       color: activeQType === t ? "#8B5CF6" : COLORS.text,
//                       transition: "all 0.15s",
//                     }}
//                   >
//                     {t} {t === "All" ? `(${questions.length})` : `(${questions.filter((q) => q.type === t).length})`}
//                   </Box>
//                 ))}
//               </Box>

//               {/* Questions list */}
//               <Box sx={{ overflowY: "auto", flex: 1, px: "24px", py: "16px", display: "flex", flexDirection: "column", gap: "14px" }}>
//                 {visibleQs.length === 0 ? (
//                   <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: COLORS.text, opacity: 0.4, textAlign: "center", mt: 4 }}>
//                     No questions in this category
//                   </Typography>
//                 ) : (
//                   visibleQs.map((q, idx) => (
//                     <Box
//                       key={idx}
//                       sx={{
//                         background: COLORS.primary,
//                         border: COLORS.border,
//                         borderRadius: "12px",
//                         p: "16px 18px",
//                       }}
//                     >
//                       {/* Badges row */}
//                       <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mb: "10px", flexWrap: "wrap" }}>
//                         <Box sx={{ px: "8px", py: "2px", borderRadius: "20px", fontSize: "11px", fontWeight: 500, fontFamily: "Poppins", background: TYPE_STYLES[q.type]?.bg || "#F3F4F6", color: TYPE_STYLES[q.type]?.color || "#555" }}>
//                           {q.type}
//                         </Box>
//                         <Box sx={{ px: "8px", py: "2px", borderRadius: "20px", fontSize: "11px", fontWeight: 500, fontFamily: "Poppins", background: DIFFICULTY_STYLES[q.difficulty]?.bg || "#F3F4F6", color: DIFFICULTY_STYLES[q.difficulty]?.color || "#555" }}>
//                           {q.difficulty}
//                         </Box>
//                         <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", color: COLORS.text, opacity: 0.35, ml: "auto" }}>
//                           Q{idx + 1}
//                         </Typography>
//                       </Box>

//                       {/* Question text */}
//                       <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", fontWeight: 500, color: COLORS.text, lineHeight: 1.6, mb: "12px" }}>
//                         {q.question}
//                       </Typography>

//                       {/* Expected answer points */}
//                       {q.expected_answer_points?.length > 0 && (
//                         <Box sx={{ background: COLORS.background, borderRadius: "8px", p: "12px 14px" }}>
//                           <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mb: "8px" }}>
//                             <EmojiObjectsOutlinedIcon sx={{ fontSize: 14, color: "#F59E0B" }} />
//                             <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", fontWeight: 600, color: "#F59E0B", textTransform: "uppercase", letterSpacing: "0.05em" }}>
//                               Key Answer Points
//                             </Typography>
//                           </Box>
//                           {q.expected_answer_points.map((point, pi) => (
//                             <Box key={pi} sx={{ display: "flex", gap: "8px", mb: pi < q.expected_answer_points.length - 1 ? "6px" : 0 }}>
//                               <Box sx={{ width: 5, height: 5, borderRadius: "50%", background: COLORS.text, opacity: 0.3, mt: "6px", flexShrink: 0 }} />
//                               <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, opacity: 0.7, lineHeight: 1.6 }}>
//                                 {point}
//                               </Typography>
//                             </Box>
//                           ))}
//                         </Box>
//                       )}
//                     </Box>
//                   ))
//                 )}
//               </Box>

//               {/* Footer */}
//               <Box sx={{ px: "24px", py: "14px", borderTop: COLORS.border, background: COLORS.primary, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
//                 <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, opacity: 0.45 }}>
//                   {visibleQs.length} question{visibleQs.length !== 1 ? "s" : ""} shown
//                 </Typography>
//                 <Button
//                   onClick={() => setQuestionsOpen(false)}
//                   sx={{ fontFamily: "Poppins", fontSize: "13px", textTransform: "none", color: COLORS.text, border: COLORS.border, borderRadius: "8px", px: "16px", py: "6px", background: COLORS.background, "&:hover": { background: COLORS.button_edit_bg } }}
//                 >
//                   Close
//                 </Button>
//               </Box>
//             </>
//           )}
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default InterviewerDashboard;










































// InterviewerDashboard.jsx — full updated file
import React, { useState, useEffect, useRef } from "react";
import {
  Box, Button, IconButton, InputBase, Paper, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography,
  Select, MenuItem, Tooltip, Modal, Divider, CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CloseIcon from "@mui/icons-material/Close";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import LightModeIcon from "@mui/icons-material/LightMode";   // ← NEW
import DarkModeIcon from "@mui/icons-material/DarkMode";     // ← NEW
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import FeedbackForm from "../FeedbackForm";
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";
import { logout } from "../../../Redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import logo from "../../../components/home/assets/images/logoAi.png";

// ─── Difficulty badge colors ───────────────────────────────────────────────
const DIFFICULTY_STYLES = {
  Easy:   { bg: "#E8F5E9", color: "#22C55E" },
  Medium: { bg: "#FFF3E0", color: "#F59E0B" },
  Hard:   { bg: "#FEECEC", color: "#EF4444" },
};

// ─── Type badge colors ─────────────────────────────────────────────────────
const TYPE_STYLES = {
  Technical:                { bg: "#EDE9FE", color: "#8B5CF6" },
  "Scenario-Based":         { bg: "#E0F2FE", color: "#0284C7" },
  HR:                       { bg: "#FCE7F3", color: "#DB2777" },
  "Missing Skills (AI/ML)": { bg: "#FEF3C7", color: "#D97706" },
};

// ─── Parse the raw API string → structured array ──────────────────────────
const parseQuestions = (raw) => {
  try {
    const cleaned =
      typeof raw === "string"
        ? raw.replace(/^"|"$/g, "").replace(/\\n/g, "\n").replace(/\\"/g, '"')
        : raw;
    const obj = typeof cleaned === "string" ? JSON.parse(cleaned) : cleaned;
    return obj?.interview_questions || [];
  } catch {
    return [];
  }
};

const InterviewerDashboard = () => {
  const [interviews, setInterviews]               = useState([]);
  const [searchQuery, setSearchQuery]             = useState("");
  const [activeFilter, setActiveFilter]           = useState("all");
  const [formData, setFormData]                   = useState({ interviewId: "" });
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  // Profile popup
  const [profileOpen, setProfileOpen]             = useState(false);
  const profileRef                                = useRef(null);

  // Questions modal
  const [questionsOpen, setQuestionsOpen]         = useState(false);
  const [questionsLoading, setQuestionsLoading]   = useState(false);
  const [questions, setQuestions]                 = useState([]);
  const [activeQType, setActiveQType]             = useState("All");
  const [selectedInterview, setSelectedInterview] = useState(null);

  const aiDishaApi      = createInstance("DISHA");
  const organizationId  = window.sessionStorage.getItem("organizationId");
  const interviewerId   = window.sessionStorage.getItem("orgUserId");
  const interviewerName = window.sessionStorage.getItem("userName") || "Interviewer";
  const interviewerEmail= window.sessionStorage.getItem("userEmail") || "";
  // ── NEW: org logo from session ─────────────────────────────────────────
  const orgLogo         = {logo} || "";
  const orgName         = window.sessionStorage.getItem("orgName") || "Org";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ── NEW: pull toggleTheme from your existing context ──────────────────
  const { COLORS, theme, toggleTheme } = useThemeMode();

  // Close profile popup on outside click
  useEffect(() => {
    const handler = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target))
        setProfileOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // ── Data fetching ──────────────────────────────────────────────────────
  const fetchInterviews = async () => {
    try {
      const response = await aiDishaApi.get(
        `/Org_User_upcoming_interviews?interviewer_id=${interviewerId}&organization_id=${organizationId}`
      );
      setInterviews(response.data["upcoming_interviews"]);
    } catch (error) {
      console.log("Error fetching interview details", error);
      Toast.error("Failed to fetch interviews. Please try again.");
    }
  };

  const handleGenerateQuestions = async (interview) => {
    setSelectedInterview(interview);
    setQuestionsOpen(true);
    setQuestionsLoading(true);
    setQuestions([]);
    setActiveQType("All");
    try {
      const response = await aiDishaApi.post(
        `/generate_interview_questions?candidate_id=${interview.candidate_id}`
      );
      setQuestions(parseQuestions(response.data));
    } catch (error) {
      console.error("Error generating questions:", error);
      Toast.error("Failed to generate questions. Please try again.");
      setQuestionsOpen(false);
    } finally {
      setQuestionsLoading(false);
    }
  };

  const handleInterviewStatusChange = async (interview, status) => {
    if (!window.confirm(`Are you sure you want to ${status} this interview?`)) return;
    try {
      const response = await aiDishaApi.patch(
        `/accept/reject/interviews?organization_id=${organizationId}&interviewer_id=${interviewerId}&interview_id=${interview.interview_id}&Status=${status}`
      );
      if (response.data.message === "Interview Status Updated!") {
        Toast.success(`Interview ${status.toLowerCase()}ed successfully!`);
        fetchInterviews();
      } else {
        Toast.error(`Failed to ${status.toLowerCase()} interview. Please try again.`);
      }
    } catch (error) {
      console.error(`Error ${status.toLowerCase()}ing interview:`, error);
      Toast.error(
        error.response?.data?.detail ||
        `Failed to ${status.toLowerCase()} interview. Please verify interview details.`
      );
    }
  };

  const handleLogOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(logout());
    setTimeout(() => navigate("/"), 0);
  };

  useEffect(() => { fetchInterviews(); }, []);

  const handleFeedbackModalOpen  = (id) => { setFormData({ interviewId: id }); setIsFeedbackModalOpen(true); };
  const handleFeedbackModalClose = () => setIsFeedbackModalOpen(false);

  // ── Helpers ────────────────────────────────────────────────────────────
  const formatDate = (dateTimeString) => {
    if (!dateTimeString) return { date: "N/A", time: "" };
    const date    = new Date(dateTimeString);
    const day     = date.getDate().toString().padStart(2, "0");
    const month   = date.toLocaleString("default", { month: "short" });
    const year    = date.getFullYear();
    const hours   = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return { date: `${day} ${month} ${year}`, time: `${hours}:${minutes}` };
  };

  const getInterviewerStatus = (interview) => {
    if (Array.isArray(interview.Interviewer_acceptance)) {
      return (
        interview.Interviewer_acceptance.find(
          (item) => item.interviewer_id === interviewerId
        )?.status || "Pending"
      );
    }
    return "Pending";
  };

  const getStatusChip = (status) => {
    const map = {
      Pending:       { label: "Pending",      bg: "#FFF8E1", color: "#F59E0B" },
      Accept:        { label: "Accepted",     bg: "#E8F5E9", color: "#22C55E" },
      Reject:        { label: "Rejected",     bg: "#FEECEC", color: "#EF4444" },
      "Re-Schedule": { label: "Re-scheduled", bg: "#EDE9FE", color: "#8B5CF6" },
    };
    const s = map[status] || map["Pending"];
    return (
      <Box sx={{ display: "inline-flex", alignItems: "center", gap: "6px", px: "10px", py: "3px", borderRadius: "20px", background: s.bg, fontSize: "12px", fontWeight: 500, color: s.color, fontFamily: "Poppins", whiteSpace: "nowrap" }}>
        <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: s.color, flexShrink: 0 }} />
        {s.label}
      </Box>
    );
  };

  const getSelectValue = (interview) => {
    const s = getInterviewerStatus(interview);
    return ["Accept", "Reject", "Re-Schedule"].includes(s) ? s : "";
  };

  const getInitials = (name) =>
    name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2);

  // ── Stats ──────────────────────────────────────────────────────────────
  const totalUpcoming = interviews.length;
  const totalAccepted = interviews.filter((i) => getInterviewerStatus(i) === "Accept").length;
  const totalPending  = interviews.filter((i) => getInterviewerStatus(i) === "Pending").length;

  // ── Filter + search ────────────────────────────────────────────────────
  const filteredInterviews = interviews.filter((interview) => {
    const status = getInterviewerStatus(interview).toLowerCase();
    const matchesFilter =
      activeFilter === "all" ||
      (activeFilter === "accepted" && status === "accept") ||
      (activeFilter === "pending"  && status === "pending") ||
      (activeFilter === "rejected" && status === "reject");
    const q = searchQuery.toLowerCase();
    const matchesSearch =
      !q ||
      interview.candidate_name?.toLowerCase().includes(q) ||
      interview.job_title?.toLowerCase().includes(q) ||
      interview.round?.toLowerCase().includes(q);
    return matchesFilter && matchesSearch;
  });

  // ── Questions filtering ────────────────────────────────────────────────
  const qTypes    = ["All", ...new Set(questions.map((q) => q.type))];
  const visibleQs = activeQType === "All" ? questions : questions.filter((q) => q.type === activeQType);

  // ── Stat card config ───────────────────────────────────────────────────
  const statCards = [
    { label: "Upcoming", value: totalUpcoming, sub: "Total scheduled", icon: <CalendarTodayIcon sx={{ fontSize: 15 }} /> },
    { label: "Accepted", value: totalAccepted, sub: "Confirmed",        icon: <CheckCircleOutlineIcon sx={{ fontSize: 15 }} /> },
    { label: "Pending",  value: totalPending,  sub: "Awaiting action",  icon: <AccessTimeIcon sx={{ fontSize: 15 }} /> },
    { label: "Feedback", value: totalAccepted, sub: "To submit",        icon: <ChatBubbleOutlineIcon sx={{ fontSize: 15 }} /> },
  ];

  const filterOptions = [
    { key: "all",      label: "All" },
    { key: "pending",  label: "Pending" },
    { key: "accepted", label: "Accepted" },
    { key: "rejected", label: "Rejected" },
  ];

  const columnHeaders = ["Interview Slot", "Candidate", "Job", "Round", "Meeting", "Status", "Action"];
  const cellSx  = { px: "14px", py: "12px", border: 0 };
  const textSx  = { fontFamily: "Poppins", fontSize: "13px", color: COLORS.text };

  // ── NEW: is dark mode active? ──────────────────────────────────────────
  // const isDark = mode === "dark";

  return (
    <Box sx={{ backgroundColor: COLORS.background, minHeight: "100vh", p: "24px 28px", margin: 0 }}>

      {/* ── Top Bar ── */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 3 }}>

        {/* LEFT: org logo + page title */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "14px" }}>

          {/* ── NEW: Organisation Logo ── */}
          {orgLogo ? (
            <Box
              component="img"
              src={logo}
              alt={orgName}
              sx={{
                height: 50,
                maxWidth: 150,
                objectFit: "contain",
                borderRadius: "8px",
                border: COLORS.border,
                background: "white",
                p: "4px 8px",
              }}
            />
          ) : (
            /* Fallback: initials pill when no logo URL is stored */
            <Box
              sx={{
                height: 40,
                px: "12px",
                borderRadius: "8px",
                border: COLORS.border,
                background: COLORS.primary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "Poppins",
                fontSize: "13px",
                fontWeight: 700,
                color: COLORS.text,
                letterSpacing: "0.04em",
              }}
            >
              {orgName.slice(0, 3).toUpperCase()}
            </Box>
          )}

          {/* Thin vertical divider between logo and title */}
          <Box sx={{ width: "1px", height: 32, background: COLORS.border?.replace("1px solid ", "") || "#ddd" }} />

          <Box>
            <Typography sx={{ fontFamily: "Poppins", fontSize: "20px", fontWeight: 500, color: COLORS.text }}>
              Interview Schedule
            </Typography>
            <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: COLORS.text, opacity: 0.5, mt: "2px" }}>
              {new Date().toLocaleDateString("en-GB", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
            </Typography>
          </Box>
        </Box>

        {/* RIGHT: Profile avatar + popup */}
        <Box ref={profileRef} sx={{ position: "relative" }}>
          <Tooltip title="Profile">
            <Box
              onClick={() => setProfileOpen((p) => !p)}
              sx={{
                width: 38, height: 38, borderRadius: "50%",
                background: COLORS.button_edit_bg,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "13px", fontWeight: 600, color: COLORS.text, fontFamily: "Poppins",
                cursor: "pointer", border: COLORS.border,
                "&:hover": { opacity: 0.85 },
              }}
            >
              <AccountCircleIcon sx={{ fontSize: 35 }} />
            </Box>
          </Tooltip>

          {/* Dropdown popup */}
          {profileOpen && (
            <Box
              sx={{
                position: "absolute", top: "48px", right: 0, zIndex: 1300,
                background: COLORS.primary, border: COLORS.border,
                borderRadius: "12px", width: "230px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <Box sx={{ px: "16px", pt: "16px", pb: "12px" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <Box sx={{
                    width: 40, height: 40, borderRadius: "50%",
                    background: COLORS.button_edit_bg,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "14px", fontWeight: 600, color: COLORS.text, fontFamily: "Poppins",
                    flexShrink: 0,
                  }}>
                    {getInitials(interviewerName)}
                  </Box>
                  <Box sx={{ overflow: "hidden" }}>
                    <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", fontWeight: 600, color: COLORS.text, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {interviewerName}
                    </Typography>
                    <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", color: COLORS.text, opacity: 0.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {interviewerEmail}
                    </Typography>
                  </Box>
                </Box>

                {/* Online status */}
                <Box sx={{ display: "flex", alignItems: "center", gap: "5px", mt: "10px" }}>
                  <FiberManualRecordIcon sx={{ fontSize: 10, color: "#22C55E" }} />
                  <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", color: "#22C55E", fontWeight: 500 }}>
                    Online
                  </Typography>
                </Box>
              </Box>

              <Divider sx={{ borderColor: COLORS.border?.replace("1px solid ", "") || "#eee" }} />

              {/* Menu items */}
              <Box sx={{ py: "8px" }}>
                <Box
                  sx={{
                    display: "flex", alignItems: "center", gap: "10px",
                    px: "16px", py: "9px", cursor: "pointer",
                    "&:hover": { background: COLORS.background },
                  }}
                >
                  <PersonOutlineIcon sx={{ fontSize: 17, color: COLORS.text, opacity: 0.6 }} />
                  <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: COLORS.text }}>
                    Interviewer Dashboard
                  </Typography>
                </Box>

                <Divider sx={{ borderColor: COLORS.border?.replace("1px solid ", "") || "#eee", my: "4px" }} />

                {/* ── NEW: Day / Night mode toggle ── */}
                <Box
                  onClick={toggleTheme}
                  sx={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    px: "16px", py: "9px", cursor: "pointer",
                    "&:hover": { background: COLORS.background },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {theme === "light" 
                      ? <LightModeIcon sx={{ fontSize: 17, color: "#F59E0B" }} />
                      : <DarkModeIcon  sx={{ fontSize: 17, color: COLORS.text, opacity: 0.6 }} />
                    }
                    <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: COLORS.text }}>
                      {theme === "light" ? "Light Mode" : "Dark Mode"}
                    </Typography>
                  </Box>

                  {/* Toggle pill */}
                  <Box
                    sx={{
                      width: 36, height: 20, borderRadius: "10px",
                      background: theme === "light" ? "#8B5CF6" : COLORS.button_edit_bg,
                      border: COLORS.border,
                      position: "relative",
                      transition: "background 0.2s",
                      flexShrink: 0,
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "3px",
                        left: theme === "light" ? "18px" : "3px",
                        width: 14, height: 14, borderRadius: "50%",
                        background: theme === "light" ? "#fff" : COLORS.text,
                        opacity: theme === "light" ? 1 : 0.5,
                        transition: "left 0.2s",
                      }}
                    />
                  </Box>
                </Box>

                <Divider sx={{ borderColor: COLORS.border?.replace("1px solid ", "") || "#eee", my: "4px" }} />

                <Box
                  onClick={handleLogOut}
                  sx={{
                    display: "flex", alignItems: "center", gap: "10px",
                    px: "16px", py: "9px", cursor: "pointer",
                    "&:hover": { background: "#FEECEC" },
                  }}
                >
                  <LogoutIcon sx={{ fontSize: 17, color: "#EF4444" }} />
                  <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: "#EF4444", fontWeight: 500 }}>
                    Logout
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      {/* ── Stat Cards ── */}
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "12px", mb: 3 }}>
        {statCards.map((card) => (
          <Box key={card.label} sx={{ background: COLORS.primary, border: COLORS.border, borderRadius: "12px", p: "14px 16px" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mb: "6px", color: COLORS.text, opacity: 0.55 }}>
              {card.icon}
              <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                {card.label}
              </Typography>
            </Box>
            <Typography sx={{ fontFamily: "Poppins", fontSize: "24px", fontWeight: 500, color: COLORS.text }}>
              {card.value}
            </Typography>
            <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, opacity: 0.45, mt: "2px" }}>
              {card.sub}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* ── Toolbar ── */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
        <Paper sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: "260px", borderRadius: "8px", background: COLORS.primary, border: COLORS.border, boxShadow: "none" }}>
          <IconButton sx={{ p: "6px", color: COLORS.text }} aria-label="search">
            <SearchIcon sx={{ fontSize: 18 }} />
          </IconButton>
          <InputBase
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search candidate, job or round…"
            sx={{ ml: 0.5, flex: 1, fontFamily: "Poppins", fontSize: "13px", "& .MuiInputBase-input::placeholder": { color: `${COLORS.text} !important`, opacity: 0.5 }, color: COLORS.text }}
          />
        </Paper>

        <Box sx={{ display: "flex", gap: "6px" }}>
          {filterOptions.map((f) => (
            <Box
              key={f.key}
              onClick={() => setActiveFilter(f.key)}
              sx={{
                px: "14px", py: "5px", borderRadius: "20px", cursor: "pointer",
                fontFamily: "Poppins", fontSize: "12px", fontWeight: 500,
                border: "0.5px solid",
                borderColor: activeFilter === f.key ? "transparent" : COLORS.border?.replace("1px solid ", "") || "#ddd",
                background: activeFilter === f.key ? COLORS.button_edit_bg : COLORS.primary,
                color: COLORS.text,
                transition: "background 0.15s",
              }}
            >
              {f.label}
            </Box>
          ))}
        </Box>
      </Box>

      {/* ── Table ── */}
      <TableContainer component={Paper} sx={{ borderRadius: "12px", border: COLORS.border, boxShadow: "none", background: COLORS.primary }}>
        <Table size="small">
          <TableHead sx={{ background: COLORS.primary }}>
            <TableRow>
              {columnHeaders.map((h) => (
                <TableCell key={h} sx={{ fontFamily: "Poppins", fontSize: "11px", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.05em", color: COLORS.text, opacity: 0.55, borderBottom: COLORS.border, py: "10px", px: "14px" }}>
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredInterviews.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} sx={{ textAlign: "center", py: 5, color: COLORS.text, opacity: 0.4, fontFamily: "Poppins", fontSize: "14px", border: 0 }}>
                  No interviews found
                </TableCell>
              </TableRow>
            ) : (
              filteredInterviews.map((interview) => {
                const { date, time } = formatDate(interview.interview_date_and_time);
                const status = getInterviewerStatus(interview);
                return (
                  <TableRow
                    key={interview.interview_id}
                    sx={{ background: COLORS.background, borderBottom: COLORS.border, "&:last-child td": { borderBottom: 0 }, transition: "background 0.1s" }}
                  >
                    <TableCell sx={cellSx}>
                      <Typography sx={{ ...textSx, fontWeight: 500 }}>{date}</Typography>
                      <Typography sx={{ ...textSx, fontSize: "12px", opacity: 0.5, mt: "1px" }}>{time}</Typography>
                    </TableCell>
                    <TableCell sx={cellSx}>
                      <Typography sx={{ ...textSx, fontWeight: 500 }}>{interview.candidate_name}</Typography>
                    </TableCell>
                    <TableCell sx={cellSx}>
                      <Typography sx={textSx}>{interview.job_title}</Typography>
                    </TableCell>
                    <TableCell sx={cellSx}>
                      <Box sx={{ display: "inline-flex", alignItems: "center", px: "10px", py: "3px", borderRadius: "20px", background: COLORS.button_edit_bg, fontFamily: "Poppins", fontSize: "11px", fontWeight: 500, color: COLORS.text, whiteSpace: "nowrap" }}>
                        {interview.round}
                      </Box>
                    </TableCell>
                    <TableCell sx={cellSx}>
                      <Box component="a" href={interview.meeting_link} target="_blank" rel="noopener noreferrer"
                        sx={{ display: "inline-flex", alignItems: "center", gap: "4px", px: "10px", py: "4px", borderRadius: "6px", background: COLORS.button_edit_bg, color: COLORS.text, textDecoration: "none", fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, "&:hover": { opacity: 0.8 } }}
                      >
                        <VideoCallIcon sx={{ fontSize: 15 }} /> Join
                      </Box>
                    </TableCell>
                    <TableCell sx={cellSx}>{getStatusChip(status)}</TableCell>
                    <TableCell sx={cellSx}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <Select
                          value={getSelectValue(interview)}
                          onChange={(e) => handleInterviewStatusChange(interview, e.target.value)}
                          displayEmpty
                          sx={{ fontFamily: "Poppins", fontSize: "12px", height: "32px", background: COLORS.background, color: COLORS.text, border: COLORS.border, borderRadius: "6px", "& .MuiSelect-icon": { color: COLORS.text }, "& .MuiOutlinedInput-notchedOutline": { border: "none" }, "&:hover": { background: COLORS.primary } }}
                        >
                          <MenuItem value="" disabled sx={{ color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Action</MenuItem>
                          <MenuItem value="Accept"      sx={{ color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Accept</MenuItem>
                          <MenuItem value="Reject"      sx={{ color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Reject</MenuItem>
                          <MenuItem value="Re-Schedule" sx={{ color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Re-schedule</MenuItem>
                        </Select>
                        <Tooltip title="Submit feedback">
                          <IconButton size="small" onClick={() => handleFeedbackModalOpen(interview.interview_id)}
                            sx={{ color: COLORS.text, border: COLORS.border, borderRadius: "6px", p: "5px", background: COLORS.background, "&:hover": { background: COLORS.primary } }}
                          >
                            <ChatBubbleOutlineIcon sx={{ fontSize: 22 }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Generate interview questions">
                          <IconButton size="small" onClick={() => handleGenerateQuestions(interview)}
                            sx={{ color: "#8B5CF6", border: "1px solid #EDE9FE", borderRadius: "6px", p: "5px", background: "#EDE9FE", "&:hover": { background: "#DDD6FE" } }}
                          >
                            <AutoAwesomeIcon sx={{ fontSize: 22 }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ── Feedback Form ── */}
      <FeedbackForm
        isOpen={isFeedbackModalOpen}
        onClose={handleFeedbackModalClose}
        organizationId={organizationId}
        interviewId={formData.interviewId}
      />

      {/* ── Interview Questions Modal ── */}
      <Modal open={questionsOpen} onClose={() => setQuestionsOpen(false)}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: { xs: "95vw", md: "780px" }, maxHeight: "88vh", background: COLORS.background, borderRadius: "16px", boxShadow: "0 24px 64px rgba(0,0,0,0.18)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <Box sx={{ px: "24px", py: "18px", background: COLORS.primary, borderBottom: COLORS.border, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Box sx={{ width: 34, height: 34, borderRadius: "8px", background: "#EDE9FE", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <AutoAwesomeIcon sx={{ fontSize: 18, color: "#8B5CF6" }} />
              </Box>
              <Box>
                <Typography sx={{ fontFamily: "Poppins", fontSize: "15px", fontWeight: 600, color: COLORS.text }}>
                  AI-Generated Interview Questions
                </Typography>
                {selectedInterview && (
                  <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, opacity: 0.5 }}>
                    {selectedInterview.candidate_name} · {selectedInterview.job_title} · {selectedInterview.round}
                  </Typography>
                )}
              </Box>
            </Box>
            <IconButton onClick={() => setQuestionsOpen(false)} sx={{ color: COLORS.text, p: "6px" }}>
              <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Box>

          {questionsLoading ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 8, gap: 2 }}>
              <CircularProgress size={36} sx={{ color: "#8B5CF6" }} />
              <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: COLORS.text, opacity: 0.6 }}>
                Generating questions…
              </Typography>
            </Box>
          ) : (
            <>
              <Box sx={{ px: "24px", py: "12px", display: "flex", gap: "6px", flexWrap: "wrap", borderBottom: COLORS.border, background: COLORS.primary, flexShrink: 0 }}>
                {qTypes.map((t) => (
                  <Box key={t} onClick={() => setActiveQType(t)}
                    sx={{ px: "12px", py: "4px", borderRadius: "20px", cursor: "pointer", fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, border: "0.5px solid", borderColor: activeQType === t ? "transparent" : COLORS.border?.replace("1px solid ", "") || "#ddd", background: activeQType === t ? "#EDE9FE" : COLORS.background, color: activeQType === t ? "#8B5CF6" : COLORS.text, transition: "all 0.15s" }}
                  >
                    {t} {t === "All" ? `(${questions.length})` : `(${questions.filter((q) => q.type === t).length})`}
                  </Box>
                ))}
              </Box>

              <Box sx={{ overflowY: "auto", flex: 1, px: "24px", py: "16px", display: "flex", flexDirection: "column", gap: "14px" }}>
                {visibleQs.length === 0 ? (
                  <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", color: COLORS.text, opacity: 0.4, textAlign: "center", mt: 4 }}>
                    No questions in this category
                  </Typography>
                ) : (
                  visibleQs.map((q, idx) => (
                    <Box key={idx} sx={{ background: COLORS.primary, border: COLORS.border, borderRadius: "12px", p: "16px 18px" }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mb: "10px", flexWrap: "wrap" }}>
                        <Box sx={{ px: "8px", py: "2px", borderRadius: "20px", fontSize: "11px", fontWeight: 500, fontFamily: "Poppins", background: TYPE_STYLES[q.type]?.bg || "#F3F4F6", color: TYPE_STYLES[q.type]?.color || "#555" }}>{q.type}</Box>
                        <Box sx={{ px: "8px", py: "2px", borderRadius: "20px", fontSize: "11px", fontWeight: 500, fontFamily: "Poppins", background: DIFFICULTY_STYLES[q.difficulty]?.bg || "#F3F4F6", color: DIFFICULTY_STYLES[q.difficulty]?.color || "#555" }}>{q.difficulty}</Box>
                        <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", color: COLORS.text, opacity: 0.35, ml: "auto" }}>Q{idx + 1}</Typography>
                      </Box>
                      <Typography sx={{ fontFamily: "Poppins", fontSize: "13px", fontWeight: 500, color: COLORS.text, lineHeight: 1.6, mb: "12px" }}>
                        {q.question}
                      </Typography>
                      {q.expected_answer_points?.length > 0 && (
                        <Box sx={{ background: COLORS.background, borderRadius: "8px", p: "12px 14px" }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mb: "8px" }}>
                            <EmojiObjectsOutlinedIcon sx={{ fontSize: 14, color: "#F59E0B" }} />
                            <Typography sx={{ fontFamily: "Poppins", fontSize: "11px", fontWeight: 600, color: "#F59E0B", textTransform: "uppercase", letterSpacing: "0.05em" }}>Key Answer Points</Typography>
                          </Box>
                          {q.expected_answer_points.map((point, pi) => (
                            <Box key={pi} sx={{ display: "flex", gap: "8px", mb: pi < q.expected_answer_points.length - 1 ? "6px" : 0 }}>
                              <Box sx={{ width: 5, height: 5, borderRadius: "50%", background: COLORS.text, opacity: 0.3, mt: "6px", flexShrink: 0 }} />
                              <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, opacity: 0.7, lineHeight: 1.6 }}>{point}</Typography>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>
                  ))
                )}
              </Box>

              <Box sx={{ px: "24px", py: "14px", borderTop: COLORS.border, background: COLORS.primary, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                <Typography sx={{ fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, opacity: 0.45 }}>
                  {visibleQs.length} question{visibleQs.length !== 1 ? "s" : ""} shown
                </Typography>
                <Button onClick={() => setQuestionsOpen(false)} sx={{ fontFamily: "Poppins", fontSize: "13px", textTransform: "none", color: COLORS.text, border: COLORS.border, borderRadius: "8px", px: "16px", py: "6px", background: COLORS.background, "&:hover": { background: COLORS.button_edit_bg } }}>
                  Close
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default InterviewerDashboard;